module.exports = __webpack_public_path__ + "static/img/yx7.2ce4965.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yx7.jpg
// module id = QFkR
// module chunks = 1